var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ufv-page-not-found-container"},[_c('div',{staticClass:"text-h5 font-weight-medium"},[_vm._v(" Você não tem permissão para acessar esta página! ")]),_c('br'),_c('v-btn',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t("Home")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }